import { Box, Button, Grid2, TablePagination } from "@mui/material";
import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import "../Assistant/Assistant.css";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import {
  createContactList,
  deleteContactList,
  editContactList,
  getContactList,
} from "../../services/ContactList";
import ContactListTable from "./ContactListTable";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Menu from "@mui/material/Menu";
import Loader from "../Loader";
import { useAuth } from "../../context/AuthContext";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#ECE0FF',
    color: '#747474',
    // maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    // border: '1px solid #dadde9',
    borderRadius: '15px',
    boxShadow: '0px 0px 11px 0px rgba(128, 139, 157, 0.15)',
  },
}));

const drawerWidth = 300;

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Gingerbread", 356, 16.0, 49, 3.9),
];
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#2F024E",
    color: "#fff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 10,
    border: "none",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "rgba(226, 186, 253, 0.30)",
    border: "none",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: "none",
  },
}));
const ContactList = () => {
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));

  const [pop, setPop] = useState(false);
  const handlePopOpen = () => setPop(true);
  const handlePopClose = () => setPop(false);
  const [editPop, setEditPop] = useState(false);
  // const handleEditPopOpen = () => setEditPop(true);
  const handleEditPopClose = () => setEditPop(false);

  const navigate = useNavigate();

  const [contactList, setContactList] = useState({
    name: "",
    description: "",
    listId: "",
  });
  const [errors, setErrors] = useState({
    name: "",
    description: "",
  });
  const [allContactList, setAllContactList] = useState([]);
  const [load, setLoad] = useState(false);
  const [deleteId, setDeleteId] = useState(null);


  const {userResponse}=useAuth();
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setContactList({ ...contactList, [name]: value });
  };
      // TablePagination-start
     // TablePagination-start
     const [page, setPage] = useState(0); // Page state (0-based index)
     const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page state
     const [totalPages, setTotalPages] = useState(0); // Total pages from backend
   
     const handleChangePage = (event, newPage) => {
       setPage(newPage); // Update current page
     };
   
     const handleChangeRowsPerPage = (event) => {
       setRowsPerPage(+event.target.value); // Update rows per page
       setPage(0); // Reset to page 0 when rows per page change
     };

      // TablePagination-end

  const [auth, setAuth] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const[isLoading,setIsLoading]=useState(true);

  const handleDeleteChange = (event) => {
    setAuth(event.target.checked);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditPopOpen = (data) => {
    setEditPop(true);
    setContactList({
      name: data.name,
      description: data.description,
      listId: data.listId,
    });
  };

  useEffect(() => {
    // if(userResponse?.haveNumber===true){
      getAllContactList();
    // }

    const intervalId = setInterval(() => {
  getAllContactListLoad();
}, 10000);

return () => clearInterval(intervalId);

 
  }, []);

  const getAllContactListLoad = async () => {
 
    const response = await getContactList();
    if (response?.data?.success === true) {
      setAllContactList(response.data.result?.data);
      setTotalPages(response.data.result?.totalPages); // Set the total pages from the backend

     
    } 
  };

  const getAllContactList = async () => {
    setIsLoading(true);
    const response = await getContactList();
    if (response?.data?.success === true) {
      setAllContactList(response.data.result?.data);
      setTotalPages(response.data.result?.totalPages); // Set the total pages from the backend

      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const validateFocus = (e) => {
    const fieldName = e?.target?.name;
    const fieldValue = e?.target?.value;

    let isValid = true;
    let errorMessage = "";

    if (fieldName === "name" && fieldValue === "") {
      // errorMessage = "Name is required";
      // isValid = false;
    }
    if (fieldName === "description" && fieldValue === "") {
      // errorMessage = "Description is required";
      // isValid = false;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: errorMessage,
    }));

    return isValid;
  };



  const handleDeleteOpen = (id) => {
    setDeleteId(id);
  };

  const validate = () => {
    let formErrors = {};
    let isValid = true;

    // Validate email
 
    if (!contactList.name) {
      formErrors.name ="Name is required";
      isValid = false;
    }

   

    setErrors(formErrors);
    return isValid;

}
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
   
      setLoad(true);
      const data={
        name:contactList.name,
        description:contactList.description
      }

      const response = await createContactList(data);
      if (response?.data?.success === true) {
        toast.success(response.data.message);
        setLoad(false);
        setPop(false);
        setContactList({});
        getAllContactList();
      } else {
        toast.error(response?.data?.message);

        setLoad(false);
        // setPop(false)
      }
    }
   
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    // if (validate()) {
    // if(contactList.name==="")
    let formErrors = {};
    let isValid = true;
    if (contactList.name === "") {
      formErrors.name = "name is required";
      isValid = false;

      setErrors(formErrors);
      return isValid;
    } else {
    setLoad(true);
    const response = await editContactList(contactList);
    if (response?.data?.success === true) {
      toast.success(response.data.message);
      setLoad(false);
      setEditPop(false);
      setContactList({});
      getAllContactList();
    } else {
      toast.error(response?.data?.message);

      setLoad(false);
      // setPop(false)
    }
  }
    // }
  };

  const handleDelete = async () => {
    setLoad(true);
    const response = await deleteContactList(deleteId);
    if (response?.data?.success === true) {
      toast.success(response.data.message);
      setLoad(false);
handleClose()
      getAllContactList();
    } else {
      toast.error(response?.data?.message);

      setLoad(false);
      // setPop(false)
    }
  };

  const displayedRows = allContactList?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);


  if(isLoading) return <Loader/>


  return (
    <div className="ContactList">
  <ToastContainer  
        autoClose={2000}
      />
      {/* {userResponse.haveContactList===true && <Loader/>} */}
      {/* {isLoading===true && <Loader/>} */}
      
      {displayedRows?.length > 0 ? (
        <div className="ContactListTable">
          {/* <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
            <SideBar />

            <Box
              component="main"
              sx={{
                flexGrow: 1,
                p: isLgUp ? 5 : 1,
                width: { sm: `calc(100% - ${drawerWidth}px)` },
                marginTop: isLgUp ? "0px" : "80px",
              }}
            > */}
              <div className="graient-btn mt-30">
                <Button className="display-1" onClick={handlePopOpen}>
                  CREATE AN CONTACT LIST <AutoAwesomeIcon />
                </Button>
                <Modal
                  open={pop}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box className="common-modal-box">
                  <div className="close-icons-popup">
                      <HighlightOffIcon  onClick={handlePopClose}/>
                    </div>
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h2"
                    >
                      Create Contact List
                    </Typography>
                    <div className="assistant-cnt">
                      <div className="input-common mt-20">
                      <div className="display-1">
                          <label> Name *</label>
                          <HtmlTooltip placement="right"
                            title={
                              <React.Fragment>
                                <Typography color="inherit" sx={{ fontSize: '12px', padding: '7px' }}>What name would you like to give your contact list? Choose a descriptive name that reflects the purpose or content of the list.</Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoRoundedIcon />
                          </HtmlTooltip></div>
                        <TextField
                          fullWidth
                          id="fullWidth"
                          required
                          name="name"
                          onChange={(e) => handleChange(e)}
                          onFocus={validateFocus}
                          onInput={validateFocus}
                          error={!!errors.name}
                          helperText={errors.name}
                        />
                      </div>
                      <div className="input-common mt-20">
                      <div className="display-1">
                          <label>Description (optional) </label>
                          <HtmlTooltip placement="right"
                            title={
                              <React.Fragment>
                                <Typography color="inherit" sx={{ fontSize: '12px', padding: '7px' }}>Add a brief description for your contact list (optional)</Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoRoundedIcon />
                          </HtmlTooltip></div>
                        <TextField
                          multiline
                          rows={5}
                          fullWidth
                          id="fullWidth"
                          name="description"
                          onChange={(e) => handleChange(e)}
                          onFocus={validateFocus}
                          onInput={validateFocus}
                          error={!!errors.description}
                          helperText={errors.description}
                        />
                      </div>
                    </div>
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{ justifyContent: "center" }}
                      className="mt-20 btn-cancel"
                    >
                      <div className="border-graient mt-10">
                        <Button onClick={()=>{handlePopClose();setErrors({})}}>Cancel</Button>
                      </div>
                      <div className="border-graient gradient-bg mt-10">
                        {load ? (
                          <Button>Processing...</Button>
                        ) : (
                          <Button
                            // onClick={() => {
                            //   navigate("/contact-list-table");
                            // }}
                            onClick={handleSubmit}
                          >
                            Save
                          </Button>
                        )}
                      </div>
                    </Stack>
                  </Box>
                </Modal>
              </div>

              <Grid2 container spacing={2} style={{ marginTop: 10 }}>
                <Grid2
                  item
                  size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                  className="mb-20"
                >
                  <div className="ContactListTable-main">
                    <TableContainer
                      component={Paper}
                      sx={{ maxHeight: 440, borderRadius: "20px 20px 0px 0px" }}
                    >
                      <Table
                        sx={{ minWidth: 700 }}
                        stickyHeader
                        aria-label="sticky table"
                      >
                        <TableHead>
                          <TableRow>
                            <StyledTableCell align="center">
                              Name
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              Created At
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              Description
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              Total Contacts
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              Action
                            </StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {displayedRows?.length > 0 &&
                            displayedRows?.map((row, index) => (
                              <StyledTableRow key={row.name}>
                                <StyledTableCell component="th" scope="row">
                                  <a
                                    onClick={() =>
                                      navigate("/contact-list-view", {
                                        state: { listId: row.listId },
                                      })
                                    }
                                    style={{ cursor: "pointer",color:"#0055fd",fontSize:13 }}
                                  >
                                    {/* <h4> */}
                                      {row.name}
                                      {/* </h4>{" "} */}
                                  </a>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <h4>{row.date}</h4>
                                </StyledTableCell>
                                <StyledTableCell
                                  align="center"
                                  sx={{ maxWidth: "300px" }}
                                >
                                  <p>{row.description!=""? row?.description : ' --- '} </p>{" "}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <h4>{row.totalContats}</h4>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {" "}
                                  <Stack
                                    direction="row"
                                    spacing={2}
                                    sx={{ justifyContent: "center" }}
                                  >
                                    {" "}
                                    {/* <RemoveRedEyeIcon sx={{ cursor: "pointer" }}/> */}
                                    <CreateOutlinedIcon
                                      onClick={() => handleEditPopOpen(row)}
                                      sx={{ cursor: "pointer" }}
                                    />
                                    <DeleteOutlineOutlinedIcon
                                      onClick={(e) => {
                                        handleMenu(e);
                                        handleDeleteOpen(row.listId);
                                      }}
                                    />
                                  </Stack>
                                </StyledTableCell>
                              </StyledTableRow>
                            ))}
                          <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right",
                            }}
                            keepMounted
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                          >
                            <div className="Delete-button-popup ">
                              <div className="display-11 mt-10">
                     
                                <Typography
                                  color="inherit"
                                  sx={{
                                    fontSize: "12px",
                                    textAlign: "start",
                                  }}
                                >
                                   <b style={{display:'flex',gap:'5px'}}>    <span className="red">
                                  <ErrorOutlineIcon />
                                </span>{" "}Delete this item</b>
                                  Are you sure to delete this item?
                                </Typography>
                              </div>
                              <Stack
                                direction="row"
                                spacing={2}
                                sx={{ justifyContent: "center" }}
                                className="assitant-stack"
                              >
                                <div className="border-graient Delete-button mt-10">
                                  <Button onClick={() => handleClose()}>
                                    NO
                                  </Button>
                                </div>
                                <div className="border-graient gradient-bg Delete-button mt-10">
                                  <Button onClick={() => handleDelete()}>
                                    Yes
                                  </Button>
                                </div>
                              </Stack>
                            </div>
                          </Menu>
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <div className="Pagination-main">
                  {allContactList?.length > 5 && (
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 25]}
                          component="div"
                          count={allContactList.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                      )}
                                </div>
                    <div className="modal-popup">
                      <Modal
                        open={editPop}
                        onClose={handleEditPopClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box className="common-modal-box">
                        <div className="close-icons-popup">
                      <HighlightOffIcon  onClick={handleEditPopClose}/>
                    </div>
                          <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                          >
                            Edit Contact List
                          </Typography>
                          <div className="assistant-cnt">
                            <div className="input-common mt-20">
                              <label> Name *</label>
                              <TextField
                                fullWidth
                                id="fullWidth"
                                name="name"
                                onChange={(e) => handleChange(e)}
                                value={contactList.name}
                                onFocus={validateFocus}
                                onInput={validateFocus}
                                error={!!errors.name}
                                helperText={errors.name}
                              />
                            </div>
                            <div className="input-common mt-20">
                              <label>Description (optional) </label>
                              <TextField
                                multiline
                                rows={5}
                                fullWidth
                                id="fullWidth"
                                name="description"
                                onChange={(e) => handleChange(e)}
                                value={contactList.description}
                                onFocus={validateFocus}
                                onInput={validateFocus}
                                error={!!errors.description}
                                helperText={errors.description}
                              />
                            </div>
                          </div>
                          <Stack
                            direction="row"
                            spacing={2}
                            sx={{ justifyContent: "center" }}
                            className="mt-20"
                          >
                            <div className="border-graient mt-10">
                              <Button onClick={() => handleEditPopClose()}>
                                Cancel
                              </Button>
                            </div>
                            <div className="border-graient gradient-bg mt-10">
                              {/* <Button onClick={handleEditSubmit}>Save</Button> */}
                              {load ? (
                              <Button>Processing...</Button>
                            ) : (
                              <Button
                                // onClick={() => {
                                //   navigate("/contact-list-table");
                                // }}
                                onClick={handleEditSubmit}
                              >
                                Save
                              </Button>
                            )}
                            </div>
                          </Stack>
                        </Box>
                      </Modal>
                    </div>
                  </div>
                </Grid2>
              </Grid2>
            {/* </Box>
          </Box> */}
        </div>
      ) : (
        // <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
        //   <SideBar />

        //   <Box
        //     component="main"
        //     sx={{
        //       flexGrow: 1,
        //       p: isLgUp ? 5 : 1,
        //       width: { sm: `calc(100% - ${drawerWidth}px)` },
        //       marginTop: isLgUp ? "50px" : "80px",
        //     }}
        //   >
            <Grid2 container spacing={2}>
              <Grid2
                item
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                className="mb-20"
              >
                <div className="create-assitant">
                  <h1>Create Your Contact List</h1>
                  <p>
                    Categorize customers into separate groups for better
                    targeting.
                  </p>

                  <div className="modal-popup">
                    <div className="graient-btn mt-30">
                      <Button className="display-1" onClick={handlePopOpen}>
                        CREATE AN CONTACT LIST <AutoAwesomeIcon />
                      </Button>
                    </div>
                    <Modal
                      open={pop}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                    >
                      <Box className="common-modal-box">
                      <div className="close-icons-popup">
                      <HighlightOffIcon  onClick={handlePopClose}/>
                    </div>
                        <Typography
                          id="modal-modal-title"
                          variant="h6"
                          component="h2"
                        >
                          Create Contact List
                        </Typography>
                        <div className="assistant-cnt">
                          <div className="input-common mt-20">
                          <div className="display-1">
                              <label> Name *</label>
                              <HtmlTooltip placement="right"
                                title={
                                  <React.Fragment>
                                    <Typography color="inherit" sx={{ fontSize: '12px', padding: '7px' }}>What name would you like to give your contact list? Choose a descriptive name that reflects the purpose or content of the list.</Typography>
                                  </React.Fragment>
                                }
                              >
                                <InfoRoundedIcon />
                              </HtmlTooltip></div>
                            <TextField
                              fullWidth
                              id="fullWidth"
                              required
                              name="name"
                              onChange={(e) => handleChange(e)}
                              onFocus={validateFocus}
                              onInput={validateFocus}
                              error={!!errors.name}
                              helperText={errors.name}
                            />
                          </div>
                          <div className="input-common mt-20">
                          <div className="display-1">
                              <label>Description (optional) </label>
                              <HtmlTooltip placement="right"
                                title={
                                  <React.Fragment>
                                    <Typography color="inherit" sx={{ fontSize: '12px', padding: '7px' }}>Add a brief description for your contact list (optional)</Typography>
                                  </React.Fragment>
                                }
                              >
                                <InfoRoundedIcon />
                              </HtmlTooltip></div>
                            <TextField
                              multiline
                              rows={5}
                              fullWidth
                              id="fullWidth"
                              name="description"
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                        <Stack
                          direction="row"
                          spacing={2}
                          sx={{ justifyContent: "center" }}
                          className="mt-20 btn-cancel"
                        >
                          <div className="border-graient mt-10">
                            <Button onClick={handlePopClose}>Cancel</Button>
                          </div>
                          <div className="border-graient gradient-bg mt-10">
                            {load ? (
                              <Button>Processing...</Button>
                            ) : (
                              <Button
                                // onClick={() => {
                                //   navigate("/contact-list-table");
                                // }}
                                onClick={handleSubmit}
                              >
                                Save
                              </Button>
                            )}
                          </div>
                        </Stack>
                      </Box>
                    </Modal>
                  </div>
                </div>
              </Grid2>
            </Grid2>
        //   </Box>
        // </Box>
      )}
    </div>
  );
};

export default ContactList;
